import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../../constants/constants';

export const componentKey = "IRS_STATE_REJECTED/STATE_PAYROLL_RESUBMIT";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },

        setStateList: (state, action) => {
            state.stateList = action.payload;
        },

        setSelectedState: (state, action) => {
            state.selectedState = action.payload;
        },

        setFormList: (state, action) => {
            state.formList = action.payload;
        },

        setSelectedForm: (state, action) => {
            state.selectedForm = action.payload;
        },

        setTaxYearList: (state, action) => {
            state.taxYearList = action.payload;
        },

        setSelectedTaxYear: (state, action) => {
            state.selectedTaxYear = action.payload;
        },

        setPayerList: (state, action) => {
            state.payerList = action.payload;
        },

        setSelectedPayer: (state, action) => {
            state.selectedPayer = action.payload;
        },

        setStatePayrollResubmitGridData: (state, action) => {
            state.statePayrollResubmitGridData = action.payload;
        },

        setSelectedStatePayrollResubmitGridData: (state, action) => {
            state.selectedStatePayrollResubmitGridData = action.payload;
        },

        setPaginationState: (state, action) => {
            state.paginationState = { ...state.paginationState, ...action.payload }
        },

        setReloadResubmitGridData: (state, action) => {
            state.reloadResubmitGridData = action.payload;
        },

        setUrlFormIdParam: (state, action) => {

            state.urlFormIdParam = action.payload;
        },

        setUrlPayerIdParam: (state, action) => {
            state.urlPayerIdParam = action.payload;
        },
    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },

        //Filters
        stateList: [],
        selectedState: { label: "", value: "" },

        formList: [],
        selectedForm: { label: "", value: "" },

        taxYearList: [],
        selectedTaxYear: { label: "", value: "" },

        payerList: [],
        selectedPayer: { label: "", value: "" },

        //Grid
        statePayrollResubmitGridData: [],
        selectedStatePayrollResubmitGridData: [],

        paginationState: {
            PageNumber: 1,
            PageSize: 10,
            SearchByTIN: "",
            SearchByName: "",
            IsDesc: true,
            Skip: 0,
            total: 10,
        },

        //Models
        reloadResubmitGridData: false,
        urlFormIdParam: null,
        urlPayerIdParam: null,
    }
})

export const { setLoadingState, setStateList, setSelectedState, setFormList, setSelectedForm, setTaxYearList, setSelectedTaxYear, setPayerList, setSelectedPayer, setStatePayrollResubmitGridData, setSelectedStatePayrollResubmitGridData, setPaginationState, setReloadResubmitGridData, setUrlFormIdParam, setUrlPayerIdParam } = actions; 
